import { useBaseActions } from '../base.actions';
import { timesheetConsultorAtom } from './TimsheetConsultorState';
import { useSetRecoilState } from 'recoil';
import { authAtom } from '../usuarios/AuthState';
import { history } from '../../helpers/history';
import { useAxiosWrapper } from '../../services/axiosWrapper';


function useTimesheetConsultorActions() {
  const axiosWrapper = useAxiosWrapper();
  const baseActions = useBaseActions('relatorios/timesheet-consultor', timesheetConsultorAtom);
  const baseUrl = `${process.env.REACT_APP_API_URL}/v1/relatorios/timesheet-consultor`;
  const setAuth = useSetRecoilState(authAtom);

  async function create(obj: object) {
    try {
      const recurso = await axiosWrapper.post(`${baseUrl}`, obj);
      return recurso;
    } catch (error) {
      if (error === 'Usuário inválido') {
        localStorage.removeItem('usuario');
        setAuth(null);
        history.push('/login');
      }
      throw error;
    }
  }

  return {
    list: baseActions.list,
    get: baseActions.get,
    update: baseActions.update,
    create: create,
    delete: baseActions.delete,
  };
}

export { useTimesheetConsultorActions };
